import React from "react";
import { TableColumn, TableRowData } from "../../interfaces/tables";
import { cn } from "../../lib/utils";

interface TableProps {
  columns: TableColumn[];
  data: TableRowData[];
}

const Table: React.FC<TableProps> = ({ columns, data }) => {
  return (
    <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
      <table className="min-w-full text-sm text-left rtl:text-right text-body">
        <thead className="text-xs text-white uppercase bg-borderColor dark:bg-gray-700 dark:text-gray-400">
          <tr>
            {columns.map((column) => (
              <th
                key={column.key}
                scope="col"
                className={`px-6 py-3 ${
                  column.fixed
                    ? "sticky right-0 z-10 bg-borderColor dark:bg-gray-700"
                    : ""
                }`}
              >
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className="odd:bg-blacklight even:bg-blackLightDarker border-b border-borderColor"
            >
              {columns.map((column) => (
                <td
                  key={column.key}
                  className={cn("px-6 py-4", {
                    "sticky right-0 z-10 bg-blackLightDarker": column.fixed,
                  })}
                >
                  {column.render
                    ? column.render(row[column.key], row)
                    : row[column.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
